import { Pipe, PipeTransform } from '@angular/core';
import { constant, times } from 'lodash';

@Pipe({
  name: 'timesWith',
  standalone: true,
})
export class TimesWithPipe implements PipeTransform {
  transform(n: number, entity?: any): any {
    return times(n, constant(entity));
  }
}
